var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.125 11.5H10.875C9.83945 11.5 9 12.3395 9 13.375V24.625C9 25.6605 9.83945 26.5 10.875 26.5H27.125C28.1605 26.5 29 25.6605 29 24.625V13.375C29 12.3395 28.1605 11.5 27.125 11.5ZM27.125 13.375V14.9689C26.2491 15.6822 24.8528 16.7913 21.8677 19.1287C21.2098 19.6462 19.9067 20.8893 19 20.8748C18.0934 20.8895 16.7899 19.646 16.1323 19.1287C13.1477 16.7916 11.751 15.6823 10.875 14.9689V13.375H27.125ZM10.875 24.625V17.3749C11.7701 18.0879 13.0394 19.0883 14.9741 20.6033C15.8279 21.2754 17.3231 22.759 19 22.75C20.6686 22.759 22.1449 21.2969 23.0255 20.6036C24.9602 19.0886 26.2299 18.0879 27.125 17.375V24.625H10.875Z","fill":"black"}));
}

EmailIcon.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
